export const GET_UNIT_FILE = "GET_UNIT_FILE";
export const GET_UNIT_FILE_SUCCESS = "GET_UNIT_FILE_SUCCESS";
export const GET_UNIT_FILE_ERROR = "GET_UNIT_FILE_ERROR";
export const RESET_GET_UNIT_FILE = "RESET_UNIT_FILE_STATICS";

export interface GetUnitFile {
  type: typeof GET_UNIT_FILE;
  payload: any;
}

export interface GetUnitFileSuccess {
  type: typeof GET_UNIT_FILE_SUCCESS;
  payload: any;
}

export interface GetUnitFileError {
  type: typeof GET_UNIT_FILE_ERROR;
  payload: any;
}

export interface ResetGetUnitFile {
  type: typeof RESET_GET_UNIT_FILE;
  payload: null;
}

export interface State {
  data: File | null;
  states: {
    loading: boolean;
    success: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
};

export type Actions =
  | GetUnitFile
  | GetUnitFileSuccess
  | GetUnitFileError
  | ResetGetUnitFile;